/**
 * Genehmigungen am Ticket -- F3-17, K-63.
 */

import type { components } from '../../../api/schema';
import { request } from '../../../lib/apiClient';

export type Approval = components['schemas']['ApprovalRead'];
export type ApprovalCreate = components['schemas']['ApprovalCreate'];
export type ApprovalDecision = components['schemas']['ApprovalDecisionCreate'];

export function listApprovals(ticketId: string): Promise<Approval[]> {
  return request<Approval[]>(`/tickets/${ticketId}/approvals`);
}

export function createApproval(ticketId: string, payload: ApprovalCreate): Promise<Approval> {
  return request<Approval>(`/tickets/${ticketId}/approvals`, { method: 'POST', body: payload });
}

/**
 * Die Entscheidung nennt keinen Schritt.
 *
 * Der Server ermittelt ihn aus der Sitzung -- eigener Schritt oder einer in
 * Vertretung. Eine Schrittkennung im Aufruf waere eine Einladung, sie zu
 * vertauschen.
 */
export function decideApproval(requestId: string, payload: ApprovalDecision): Promise<Approval> {
  return request<Approval>(`/approvals/${requestId}/decision`, { method: 'POST', body: payload });
}

export function cancelApproval(requestId: string): Promise<Approval> {
  return request<Approval>(`/approvals/${requestId}/actions/cancel`, { method: 'POST' });
}

export function listPendingApprovals(): Promise<Approval[]> {
  return request<Approval[]>('/approvals/pending');
}
